import { render, staticRenderFns } from "./AddUserGroup.vue?vue&type=template&id=5aef3b7c"
import script from "./AddUserGroup.vue?vue&type=script&lang=js"
export * from "./AddUserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports